import { Button } from "antd"
import { CopyOutlined } from "@ant-design/icons"

const CopyButton = ({ onClick, size = "small", type = "text", disabled = false, style = {} }) => {
  return <Button
    onClick={onClick}
    size={size}
    type={type}
    disabled={disabled}
    icon={<CopyOutlined
      style={{
        fontSize: 10,
        ...style
      }}
    />}
  />
}

export default CopyButton